import {ServiceClass} from '@/decorators';
import {AccountPlanResponse, PlanModel} from '../models/payment/payment.models';
import {BaseApi} from './base.api';

@ServiceClass()
export class PlanApiService extends BaseApi {
    public getPublicPlans(): Promise<Array<PlanModel>> {
        return this.GET_RequestAsync<Array<PlanModel>>(`${this.ApiUrl}/plans/public`);
    }

    public getPublicPlanById(planId: string): Promise<PlanModel> {
        return this.GET_RequestAsync<PlanModel>(`${this.ApiUrl}/plans/public/${planId}`);
    }

    public getAvailablePlans(accountId: string): Promise<Array<PlanModel>> {
        return this.GET_RequestAsync<Array<PlanModel>>(`${this.ApiUrl}/accounts/${accountId}/plans`);
    }

    public getActiveAccountPlan(accountId: string): Promise<AccountPlanResponse> {
        return this.GET_RequestAsync<AccountPlanResponse>(`${this.ApiUrl}/accounts/${accountId}/plan`);
    }

    public getPlanPermissions(accountId: string): Promise<{permissions: string[]}> {
        return this.GET_RequestAsync<{permissions: string[]}>(`${this.ApiUrl}/accounts/${accountId}/plan/permissions`);
    }

    public canCreateLocation(accountId: string): Promise<{allowed: boolean}> {
        return this.GET_RequestAsync<{allowed: boolean}>(`${this.ApiUrl}/accounts/${accountId}/plan/access/location`);
    }
}
